import styled from 'styled-components';

const Center = styled.div`
	width: 100vw;
	height: 100vh;
	border: 1px solid red;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export default Center;
